"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

var _howOften = _interopRequireDefault(require("../options/howOften"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.GAD7;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: "Over the last 2 weeks, how often have you been bothered by the following problems?",
  options: _howOften["default"]
};
var gadQuestions = [{
  prompt: "Feeling nervous, anxious, or on edge"
}, {
  prompt: "Not being able to stop or control worrying"
}, {
  prompt: "Worrying too much about different things"
}, {
  prompt: "Trouble relaxing"
}, {
  prompt: "Being so restless that it's hard to sit still"
}, {
  prompt: "Becoming easily annoyed or irritable"
}, {
  prompt: "Feeling afraid as if something awful might happen"
}];
var questions = (0, _utils.wrapBattery)(gadQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var score = Math.round((0, _sum2["default"])(answers));
  return {
    GAD7: score,
    GAD7_1: answers[0],
    GAD7_2: answers[1],
    GAD7_3: answers[2],
    GAD7_4: answers[3],
    GAD7_5: answers[4],
    GAD7_6: answers[5],
    GAD7_7: answers[6]
  };
}